import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Logout } from "../../services/AuthService";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import UpdateAccount from "./UpdateAccount";
import ChangePassword from "./ChangePassword";
import MyOrders from "./MyOrders";
import Address from "./Address";
import "./style.css";

const Profile = () => {
	const { t } = useTranslation();
	const auth = useSelector((state) => state?.user);
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const location = useLocation();
	const tabs = ["Account", "Change Password", "My Orders", "My Address"];
	const [selectedTab, setSelectedTab] = useState("Account");

	useEffect(() => {
		if (location?.state?.myOrder === "myOrder") setSelectedTab("My Orders");
	}, [location]);

	return (
		<div className="profile">
			<div className="container">
				<div className="row">
					<div className="col-lg-3 col-md-4 col-12">
						<div className="profile-details">
							<div className="profile-links">
								<p
									className={`${tabs[0] === selectedTab ? "active" : ""} `}
									onClick={() => setSelectedTab(tabs[0])}>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M10.0007 10C12.3018 10 14.1673 8.13454 14.1673 5.83335C14.1673 3.53217 12.3018 1.66669 10.0007 1.66669C7.69946 1.66669 5.83398 3.53217 5.83398 5.83335C5.83398 8.13454 7.69946 10 10.0007 10Z"
											fill={tabs[0] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M10.0008 12.0833C5.82578 12.0833 2.42578 14.8833 2.42578 18.3333C2.42578 18.5666 2.60911 18.75 2.84245 18.75H17.1591C17.3924 18.75 17.5758 18.5666 17.5758 18.3333C17.5758 14.8833 14.1758 12.0833 10.0008 12.0833Z"
											fill={tabs[0] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
									</svg>
									{t(tabs[0])}
								</p>
								<p
									className={`${tabs[1] === selectedTab ? "active" : ""} `}
									onClick={() => setSelectedTab(tabs[1])}>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M10.0009 14.4583C10.7511 14.4583 11.3592 13.8502 11.3592 13.1C11.3592 12.3498 10.7511 11.7416 10.0009 11.7416C9.25072 11.7416 8.64258 12.3498 8.64258 13.1C8.64258 13.8502 9.25072 14.4583 10.0009 14.4583Z"
											fill={tabs[1] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M15.2327 7.94169V6.90002C15.2327 4.65002 14.691 1.66669 9.99935 1.66669C5.30768 1.66669 4.76602 4.65002 4.76602 6.90002V7.94169C2.43268 8.23335 1.66602 9.41669 1.66602 12.325V13.875C1.66602 17.2917 2.70768 18.3334 6.12435 18.3334H13.8743C17.291 18.3334 18.3327 17.2917 18.3327 13.875V12.325C18.3327 9.41669 17.566 8.23335 15.2327 7.94169ZM9.99935 15.6167C8.60768 15.6167 7.48268 14.4834 7.48268 13.1C7.48268 11.7084 8.61602 10.5834 9.99935 10.5834C11.3827 10.5834 12.516 11.7167 12.516 13.1C12.516 14.4917 11.391 15.6167 9.99935 15.6167ZM6.12435 7.86669C6.05768 7.86669 5.99935 7.86669 5.93268 7.86669V6.90002C5.93268 4.45835 6.62435 2.83335 9.99935 2.83335C13.3743 2.83335 14.066 4.45835 14.066 6.90002V7.87502C13.9993 7.87502 13.941 7.87502 13.8743 7.87502H6.12435V7.86669Z"
											fill={tabs[1] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
									</svg>

									{t(tabs[1])}
								</p>
								<p
									className={`${tabs[2] === selectedTab ? "active" : ""} `}
									onClick={() => setSelectedTab(tabs[2])}>
									<svg
										width="20"
										height="20"
										viewBox="0 0 20 20"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M11.666 2.43335V9.35835C11.666 10.2084 10.9743 10.9 10.1243 10.9H2.49935C2.04102 10.9 1.66602 10.525 1.66602 10.0667V4.74169C1.66602 3.04169 3.04102 1.66669 4.74102 1.66669H10.891C11.3243 1.66669 11.666 2.00835 11.666 2.43335Z"
											fill={tabs[2] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M17.916 12.9167C18.1493 12.9167 18.3327 13.1 18.3327 13.3334V14.1667C18.3327 15.55 17.216 16.6667 15.8327 16.6667C15.8327 15.2917 14.7077 14.1667 13.3327 14.1667C11.9577 14.1667 10.8327 15.2917 10.8327 16.6667H9.16602C9.16602 15.2917 8.04102 14.1667 6.66602 14.1667C5.29102 14.1667 4.16602 15.2917 4.16602 16.6667C2.78268 16.6667 1.66602 15.55 1.66602 14.1667V12.5C1.66602 12.0417 2.04102 11.6667 2.49935 11.6667H10.416C11.566 11.6667 12.4993 10.7334 12.4993 9.58335V5.00002C12.4993 4.54169 12.8743 4.16669 13.3327 4.16669H14.0327C14.6327 4.16669 15.1827 4.49169 15.4827 5.00835L16.016 5.94169C16.091 6.07502 15.991 6.25002 15.8327 6.25002C14.6827 6.25002 13.7493 7.18335 13.7493 8.33335V10.8334C13.7493 11.9834 14.6827 12.9167 15.8327 12.9167H17.916Z"
											fill={tabs[2] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M6.66667 18.3333C7.58714 18.3333 8.33333 17.5871 8.33333 16.6667C8.33333 15.7462 7.58714 15 6.66667 15C5.74619 15 5 15.7462 5 16.6667C5 17.5871 5.74619 18.3333 6.66667 18.3333Z"
											fill={tabs[2] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M13.3327 18.3333C14.2532 18.3333 14.9993 17.5871 14.9993 16.6667C14.9993 15.7462 14.2532 15 13.3327 15C12.4122 15 11.666 15.7462 11.666 16.6667C11.666 17.5871 12.4122 18.3333 13.3327 18.3333Z"
											fill={tabs[2] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
										<path
											d="M18.3333 10.4417V11.6667H15.8333C15.375 11.6667 15 11.2917 15 10.8333V8.33333C15 7.875 15.375 7.5 15.8333 7.5H16.9083L18.1167 9.61667C18.2583 9.86667 18.3333 10.15 18.3333 10.4417Z"
											fill={tabs[2] === selectedTab ? "#209B99" : "#7A7C7E"}
										/>
									</svg>

									{t(tabs[2])}
								</p>
								<p
									className={`${
										tabs[3] === selectedTab ? "active mb-0" : "mb-0"
									} `}
									onClick={() => setSelectedTab(tabs[3])}>
									<svg
										width="24"
										height="24"
										viewBox="0 0 24 24"
										fill="none"
										xmlns="http://www.w3.org/2000/svg">
										<path
											d="M12.0009 13.4295C13.724 13.4295 15.1209 12.0326 15.1209 10.3095C15.1209 8.58633 13.724 7.18945 12.0009 7.18945C10.2777 7.18945 8.88086 8.58633 8.88086 10.3095C8.88086 12.0326 10.2777 13.4295 12.0009 13.4295Z"
											stroke={tabs[3] === selectedTab ? "#209B99" : "#7A7C7E"}
											strokeWidth="1.5"
										/>
										<path
											d="M3.61971 8.49C5.58971 -0.169998 18.4197 -0.159997 20.3797 8.5C21.5297 13.58 18.3697 17.88 15.5997 20.54C13.5897 22.48 10.4097 22.48 8.38971 20.54C5.62971 17.88 2.46971 13.57 3.61971 8.49Z"
											stroke={tabs[3] === selectedTab ? "#209B99" : "#7A7C7E"}
											strokeWidth="1.5"
										/>
									</svg>

									{t(tabs[3])}
								</p>
							</div>
							{/* <hr />
							<button
								className="logout"
								onClick={() => {
									Logout(auth?.accessToken, dispatch);
									navigate("/");
								}}>
								{t("Logout")}
							</button> */}
						</div>
					</div>
					<div className="col-lg-9 col-md-8 col-12">
						<div>
							{selectedTab === tabs[0] && <UpdateAccount title={selectedTab} />}
							{selectedTab === tabs[1] && (
								<ChangePassword title={selectedTab} />
							)}
							{selectedTab === tabs[2] && <MyOrders title={selectedTab} />}
							{selectedTab === tabs[3] && <Address title={selectedTab} />}
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};
export default Profile;
